(function(){
     'use strict';

     angular
        .module('appback')
        .factory('TablonService', TablonService);

    TablonService.$inject = ['$http'];

    function TablonService($http){

        var service= {
           getTablon:getTablon,
           nuevoTablon:nuevoTablon,
           addComentario:addComentario,
           deleteTablon:deleteTablon
        };

        return service;

        function getTablon(callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/site/gettablon', {  ignoreLoadingBar: true, params : {  } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function deleteTablon(id,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               id:id
            });
            $http.post('/backend/site/deletetablon', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }

        function addComentario(item,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                },
            }

            var data = $.param({
               carta:JSON.stringify(item)
            });
            $http.post('/backend/site/addcomentario', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }

        function nuevoTablon(carta,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               carta:JSON.stringify(carta)
            });
            $http.post('/backend/site/nuevotablon', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }
      
    }
})();